/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('refuel.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        refuel_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.refuel_event_set = function() {

    // タブ切り替え時
    $(document).on('click', '[data-page-type]', function() {
        $('#search-form-user_name').val('');
        $('#search-form-vehicle_name').val('');
        $('#search-form-type').val($(this).data('page-type'));
        $('#search-form-type').trigger('change');
    });

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.refuel-confirm-before-check, .refuel-confirm-after-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    /*---- 検索条件変更時 ----*/

    // 入力日時（開始）変更時
    $(document).on('change', '#search-form-started_at', function () {
        dateRange_changeStartedAt(this, '#search-form-ended_at', 31);
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#search-form-ended_at', function () {
        dateRange_changeEndedAt(this, '#search-form-started_at', 31);
    });

    // monthly社員車両切替
    $(document).on('change', '#search-form-mode', function() {
        if ($(this).val() === 'vehicle') {
            $('#search-form-user_name').val('');
        } else {
            $('#search-form-vehicle_name').val('');
        }
    });

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        const dateError = $('#search-form-started_at-errors').find('.invalid-feedback').not('.copy');
        if (dateError.text().trim() !== '') {
            excutionData.push('started_at', 'ended_at');
        }
        action = _request.create_affiliation_url(action, true, [{'name': 'company_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 営業所変更時
    $(document).on('change', '#search-form-section_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            let urlString = new URL(location.href);
            urlString.searchParams.delete('section_id');
            location.href = urlString;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        const dateError = $('#search-form-started_at-errors').find('.invalid-feedback').not('.copy');
        if (dateError.text().trim() !== '') {
            excutionData.push('started_at', 'ended_at');
        }
        action = _request.create_affiliation_url(action, true, [{'name': 'section_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // レシート条件押下時
    $(document).on('change', '#search-form-receipt', function () {
        search();
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#refuel-all-delete', function () {
        $(".refuel-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.refuel-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#refuel-all-delete, .refuel-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#refuel-multi-delete-button').prop('disabled', ($('.refuel-delete:checked').length == 0));
    });

    /*---- 削除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.refuel-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#refuel-detail-modal');
        });
    });

    /*---- 検索ボタン押下時 ----*/

    // 検索時
    $(document).on('click', '#search-form-action_search', function () {
        // コンテンツを読込
        load_contents(null, false);
    });

    /*---- 月一覧処理 ----*/

    // 詳細表示時
    $(document).on('click', '[data-monthly_detail-modal] td', function () {
        _modal.create($(this).parent('tr'), 'monthly_detail-modal', ['user_id', 'vehicle_id'], true);
    });

    // /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });


    // 月毎CSVの出力時
    $(document).on('click', '[data-csv-type]', function ()
    {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // データを追加
        datas.push({'name' : 'csv_type', 'value' : $(this).data('csv-type')});
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            // モーダルを非表示
            _modal.hide('refuel-setting-modal');

            //月毎モーダル再表示(一覧の営業所を疑似クリック)
            const mode = new URL(window.location.href).searchParams.get('mode');
            if (mode == 'user') {
                $('#' + results.user_id + '-section').trigger('click');
            } else if (mode == 'vehicle') {
                $('#' + results.vehicle_id + '-section').trigger('click');
            }
            
        });
    });
}

